webpackJsonp([1],Array(28).concat([
/* 28 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 29 */,
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify_es5_util_easing_patterns__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify_es5_util_easing_patterns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify_es5_util_easing_patterns__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    target: function target() {
      var value = this[this.type];
      if (!isNaN(value)) return Number(value);else return value;
    },
    options: function options() {
      return {
        duration: this.duration,
        offset: this.offset,
        easing: this.easing
      };
    }
  },
  data: function data() {
    return {
      type: "selector",
      selector: "#faq",
      duration: 300,
      offset: -200,
      easing: "easeInOutCubic",
      easings: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_1_vuetify_es5_util_easing_patterns__),

      isDark: false,
      currentDate: new Date().getFullYear(),
      clipped: false,
      drawer: false,
      fixed: false,
      menus: [{
        icon: "home",
        title: "Home",
        to: "/",
        isParent: false

      }, {
        icon: "question_answer",
        title: "About",
        to: "/about",
        isParent: false
      }, {
        icon: "bubble_chart",
        title: "Programs",
        to: "/programs",
        isParent: true,
        children: [{
          title: "Hackathon v1.0",
          to: "/programs",
          icon: "memory"
        }, {
          title: "Hackathon v2.0",
          to: "/programs",
          icon: "memory"
        }]
      }, {
        icon: "dashboard",
        title: "Gallery",
        to: "/gallery",
        isParent: false
      }],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: "Ethiopia Hacks"
    };
  },

  methods: {
    btnClicked: function btnClicked() {
      this.isDark = !this.isDark;
    },

    scroll: function scroll(dest) {
      this.selector = dest;
      this.$vuetify.goTo(this.target, this.options);
    }
  }
});

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_easing_patterns__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_easing_patterns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_easing_patterns__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      title: '"Ethiopia Hacks" Hackathon v2.0',
      messages: [{
        avatar: "https://avatars0.githubusercontent.com/u/9064066?v=4&s=460",
        name: "Melake Wubshet",
        title: "Welcome to Vuetify.js!",
        excerpt: "Thank you for joining our community..."
      }, {
        color: "red",
        icon: "people",
        name: "Social",
        new: 1,
        total: 3,
        title: "Twitter"
      }, {
        color: "teal",
        icon: "local_offer",
        name: "Promos",
        new: 2,
        total: 4,
        title: "Shop your way",
        exceprt: "New deals available, Join Today"
      }],

      faqList: [{
        question: "What is Hackathon?",
        answer: "A hackathon is usually a day long (can be 36 hours, 48 hours, etc.) coding competition where software programmers, developers, designers, etc. come together to build and design something cool."
      }, {
        question: "Who can attend ‘Ethiopia Hack’ hackathon?",
        answer: "Anyone who is interested in computer programming and loves to learn and build cool stuff can attend."
      }, {
        question: "But isn’t hacking illegal? ",
        answer: "The word “hack” has so much negativity attached to it that most people think hackathons are a way to “hack” into something. NOOOO. Hacking is basically building something. It could be anything."
      }, {
        question: "Do I need to have programming experience?",
        answer: "Basics of programming is enough."
      }, {
        question: "How much do I have to pay to attend the hackathon? ",
        answer: "It’s FREE. :)"
      }, {
        question: "Is it a team event?",
        answer: " Yes. So the whole point of forming teams and working on a project gives you the opportunity to work in a real life setting. I mean seriously, that’s how it works in the industry. You have to learn to work with people from different background, different skill set, etc. What better way than a hackathon to get used to it? Teams include a maximum of 5 people. Our hackathons have “Meet-and-Greet” events before the actual event where you get to talk to attendees and look for teammates."
      }, {
        question: "What can I hack at the hackathon?",
        answer: "You can build anything. A website, a web app, Android/iOS App, Chrome extension, whatever you want to on a specific theme that will be given on the hackathon day."
      }, {
        question: "What are the requirements to attend on the hackathon?",
        answer: "One requirement is your age must be between 18 to 25. Another requirement is you need to be willing to attend the hackathon for 48 hours."
      }],

      timelines: [{
        title: "Hackathon v1.0",
        theme: '"Entreprunership and Youth"',
        description: "From Nov 16-8th, 2018 at American Center, Addis Ababa",
        isPassed: true,
        isNext: false,
        isLeft: false,
        color: "red lighten-2",
        icon: "check"
      }, {
        title: "Hackathon v2.0",
        theme: "Comming Soon...",
        description: "From Jan 11-13th, 2018 at American Center, Addis Ababa",
        isPassed: false,
        isNext: true,
        isLeft: true,
        color: "purple lighten-1",
        icon: "star"
      }, {
        title: "Hackathon v3.0",
        theme: "Comming Soon...",
        description: "",
        isPassed: false,
        isNext: false,
        isLeft: false,
        color: "amber lighten-1",
        icon: "star"
      }, {
        title: "Hackathon v4.0",
        theme: "Comming Soon...",
        description: "",
        isPassed: false,
        isNext: false,
        isLeft: true,
        color: "green lighten-1",
        icon: "star"
      }, {
        title: "Hackathon v5.0",
        theme: "Comming Soon...",
        description: "",
        isPassed: false,
        isNext: false,
        isLeft: false,
        color: "indigo lighten-1",
        icon: "star"
      }]
    };
  },


  methods: {
    getImageUrl: function getImageUrl(img) {
      return __webpack_require__(36)("./" + img);
    }
  }
});

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./banner.jpg": 92,
	"./cawee.png": 93,
	"./gdg_addis.png": 94,
	"./hacking.jpg": 95,
	"./hackv1/image1.jpg": 96,
	"./hackv1/image2.jpg": 97,
	"./logo.png": 98,
	"./my_pic.jpg": 99,
	"./prize.jpg": 100,
	"./teams.jpg": 101,
	"./us_embassy.png": 102,
	"./usaid.png": 103
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36;

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__programPages_Intro_vue__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__programPages_Teams_vue__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__programPages_Schedule_vue__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__programPages_Guideline_vue__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__programPages_Winners_vue__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__programPages_Gallery_vue__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__programPages_Discussion_vue__ = __webpack_require__(122);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'intro-page': __WEBPACK_IMPORTED_MODULE_0__programPages_Intro_vue__["a" /* default */],
    'teams-page': __WEBPACK_IMPORTED_MODULE_1__programPages_Teams_vue__["a" /* default */],
    'schedule-page': __WEBPACK_IMPORTED_MODULE_2__programPages_Schedule_vue__["a" /* default */],
    'guideline-page': __WEBPACK_IMPORTED_MODULE_3__programPages_Guideline_vue__["a" /* default */],
    'winners-page': __WEBPACK_IMPORTED_MODULE_4__programPages_Winners_vue__["a" /* default */],
    'gallery-page': __WEBPACK_IMPORTED_MODULE_5__programPages_Gallery_vue__["a" /* default */],
    'discussion-page': __WEBPACK_IMPORTED_MODULE_6__programPages_Discussion_vue__["a" /* default */]
  },
  data: function data() {
    return {
      tabs: null,
      tabList: [{
        title: "Introduction",
        icon: "speaker_notes"
      }, {
        title: "Teams",
        icon: "people"
      }, {
        title: "Schedule",
        icon: "timer"
      }, {
        title: "Guideline",
        icon: "book"
      }, {
        title: "Winners",
        icon: "card_giftcard"
      }, {
        title: "Gallery",
        icon: "collections"
      }, {
        title: "Discussion",
        icon: "forum"
      }],
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
    };
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_appMixins_js__ = __webpack_require__(39);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_appMixins_js__["a" /* default */]],
  data: function data() {
    return {
      //Main Side Information
      mainSideInfo: {
        isPassed: true,
        title: "Ethiopia Hacks v1.0",
        theme: "Youth and Entreprunership",
        venue: "American Center",
        city: "Addis Ababa, Ethiopia",
        startDate: "Nov 16, 2018",
        endDate: "Nov 18, 2018"
      },

      //Attendee statistics
      attendee_statistics: [{
        icon: "mdi-account-group",
        desc: "10 Teams"
      }, {
        icon: "mdi-account",
        desc: "50 Participants"
      }, {
        icon: "mdi-human-female-female",
        desc: "15 Women"
      }, {
        icon: "mdi-human-male-male",
        desc: "35 Male"
      }],
      feedbacks: ["It was really great, it has motivated me to do more and help as much people as i can with my knowledge. And i was amazed with the staff they were 100% willing to help us. keep it up!!!👌👍👍", "The most exiting and interesting experience of my life in short", "I think it was great after all we learnt alot from each other and Networked well. The way I see it you can guys make it hard and testing not that this is not. I hope you will surprise us at the next event!"]
    };
  }
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        getImageUrl: function getImageUrl(img) {
            return __webpack_require__(36)("./" + img);
        }
    }
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_appMixins_js__ = __webpack_require__(39);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_appMixins_js__["a" /* default */]],
  data: function data() {
    return {
      teams: [{
        image: "hackv1/image1.jpg",
        name: "Trackly",
        likes: 4,
        members: ["Abebe Yohannes", "Selam Mulugeta", "Hillina Wubshet", "Abraham Mulugeta", "Sara Teshome"]
      }, {
        image: "hackv1/image1.jpg",
        name: "Adwa",
        likes: 10,
        members: ["Abebe Yohannes", "Selam Mulugeta", "Hillina Wubshet", "Abraham Mulugeta", "Sara Teshome"]
      }, {
        image: "hackv1/image1.jpg",
        name: "H.W.A",
        likes: 10,
        members: ["Abebe Yohannes", "Selam Mulugeta", "Hillina Wubshet", "Abraham Mulugeta", "Sara Teshome"]
      }, {
        image: "hackv1/image1.jpg",
        name: "Team Addis",
        likes: 15,
        members: ["Abebe Yohannes", "Selam Mulugeta", "Hillina Wubshet", "Abraham Mulugeta", "Sara Teshome"]
      }, {
        image: "hackv1/image1.jpg",
        name: "The SQUAD",
        likes: 15,
        members: ["Abebe Yohannes", "Selam Mulugeta", "Hillina Wubshet", "Abraham Mulugeta", "Sara Teshome"]
      }, {
        image: "hackv1/image1.jpg",
        name: "Team Adrash",
        likes: 15,
        members: ["Abebe Yohannes", "Selam Mulugeta", "Hillina Wubshet", "Abraham Mulugeta", "Sara Teshome"]
      }]
    };
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      schedules: [
      //Day 1
      {
        day: "16",
        dayOfWeek: "Friday",
        month: "November",
        year: "2018",
        agendas: [{
          time: "2:30pm",
          agenda: "Ethiopia Hack Launching Program",
          caption: "U.S. Embassy in Ethiopia & GDG Addis"
        }, {
          time: "3:00pm",
          agenda: "Keynote Speech on Ethiopia Hacks v1.0 challenge topic",
          caption: "By Mr. Olaf Erz | Save the Children"
        }, {
          time: "4:00pm",
          agenda: "Tea Break",
          caption: "Networking, group photo and small discussion"
        }, {
          time: "4:15pm",
          agenda: "Team Formation and Introduction",
          caption: "Formal and informal way of team formation"
        }, {
          time: "5:00pm",
          agenda: "End of Day-1",
          caption: "Meanwhile, teams start to explore problem topic"
        }]
      },
      //Day 2
      {
        day: "18",
        dayOfWeek: "Saturday",
        month: "November",
        year: "2018",
        agendas: [{
          time: "8:30am",
          agenda: "Hackathon Day-2 Start",
          caption: "Teams arrive at the venue, prepare the materials & tools"
        }, {
          time: "9am",
          agenda: "Teams Working - Problem Exploration",
          caption: "Domain experts help around"
        }, {
          time: "10:30am",
          agenda: "Coffee Break",
          caption: "Convening moment, lighting talk, group photo, ..."
        }, {
          time: "11am",
          agenda: "Teams Working - Idea generation and problem refinement",
          caption: "Design experts help around"
        }, {
          time: "12:30pm",
          agenda: "Lunch Break",
          caption: ""
        }, {
          time: "2pm",
          agenda: "Teams Working - Hacking Buiding",
          caption: "Developers help around"
        }, {
          time: "3:30pm",
          agenda: "Coffee Break",
          caption: "Convening moment, lighting talk, group photo, ..."
        }, {
          time: "4pm",
          agenda: "Teams Working - Hacking Buiding",
          caption: "Developers help around"
        }, {
          time: "5:30pm",
          agenda: "End of Day-2",
          caption: ""
        }]
      },
      //Day 3
      {
        day: "19",
        dayOfWeek: "Sunday",
        month: "November",
        year: "2018",
        agendas: [{
          time: "8:30am",
          agenda: "Hackathon Day-3 Start",
          caption: "Teams arrive at the venue, prepare the materials & tools"
        }, {
          time: "9am",
          agenda: "Teams Working - Finalize the Hacking",
          caption: "Teams also start to prepare presentation materials"
        }, {
          time: "10:30am",
          agenda: "Coffee Break",
          caption: "Convening moment, lighting talk, group photo, ..."
        }, {
          time: "11am",
          agenda: "Teams Presenting",
          caption: "The first 5 teams present their solution to the judges."
        }, {
          time: "12:30pm",
          agenda: "Lunch Break",
          caption: ""
        }, {
          time: "2pm",
          agenda: "Teams Presenting",
          caption: "The last 5 teams present their solution to the judges"
        }, {
          time: "3:30pm",
          agenda: "Awarding",
          caption: "Award ceremony"
        }, {
          time: "4pm",
          agenda: "End of Ethiopia Hacks v1.0",
          caption: "Group photo, networking, feedback"
        }]
      }]
    };
  }
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_gallery__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_gallery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_gallery__);
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        'gallery': __WEBPACK_IMPORTED_MODULE_0_vue_gallery___default.a
    },
    data: function data() {
        return {
            images: ['https://randomuser.me/api/portraits/men/1.jpg', 'https://randomuser.me/api/portraits/men/2.jpg', 'https://randomuser.me/api/portraits/men/3.jpg', 'https://randomuser.me/api/portraits/men/4.jpg', 'https://randomuser.me/api/portraits/men/5.jpg'],
            index: null
        };
    }
});

/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mdi_font_css_materialdesignicons_css__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mdi_font_css_materialdesignicons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__mdi_font_css_materialdesignicons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_components_Vuetify__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_es5_components_Vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify_es5_components_Vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_es5_components_VApp__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_es5_components_VApp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetify_es5_components_VApp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_VNavigationDrawer__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_VNavigationDrawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_VNavigationDrawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VFooter__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VList__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VBtn__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VIcon__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VGrid__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VGrid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VGrid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VToolbar__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VToolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VToolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VParallax__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VParallax___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VParallax__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VExpansionPanel__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VExpansionPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VExpansionPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_VTimeline__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_VTimeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_VTimeline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VCard__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VSwitch__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VSwitch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VSwitch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VDivider__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VDivider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VDivider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VTabs__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VTabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VTabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VSheet__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VSheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VSheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VImg__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VImg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VImg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_transitions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_transitions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_transitions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__node_modules_vuetify_src_stylus_app_styl__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__node_modules_vuetify_src_stylus_app_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__node_modules_vuetify_src_stylus_app_styl__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


























__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuetify_es5_components_Vuetify___default.a, {
  iconfont: 'mdi',
  components: {
    VApp: __WEBPACK_IMPORTED_MODULE_5_vuetify_es5_components_VApp___default.a,
    VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_VNavigationDrawer___default.a,
    VFooter: __WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VFooter___default.a,
    VList: __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VList___default.a,
    VBtn: __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VBtn___default.a,
    VIcon: __WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VIcon___default.a,
    VGrid: __WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VGrid___default.a,
    VToolbar: __WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VToolbar___default.a,
    VParallax: __WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VParallax___default.a,
    VExpansionPanel: __WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VExpansionPanel___default.a,
    VTimeline: __WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_VTimeline___default.a,
    VCard: __WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VCard___default.a,
    VSwitch: __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VSwitch___default.a,
    VDivider: __WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VDivider___default.a,
    VTabs: __WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VTabs___default.a,
    VSheet: __WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VSheet___default.a,
    VImg: __WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VImg___default.a,
    transitions: __WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_transitions___default.a
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] },
  template: '<App/>'
});

/***/ }),
/* 55 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(30);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05d9f3af_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(88);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05d9f3af_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"dark":_vm.isDark}},[_c('v-navigation-drawer',{attrs:{"mini-variant":_vm.miniVariant,"clipped":_vm.clipped,"fixed":"","app":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.miniVariant = !_vm.miniVariant}}},[_c('v-icon',{domProps:{"innerHTML":_vm._s(_vm.miniVariant ? 'chevron_right' : 'chevron_left')}})],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.clipped = !_vm.clipped}}},[_c('v-icon',[_vm._v("web")])],1)],1),_vm._v(" "),_vm._l((_vm.menus),function(menu,k){return _c('dev',{key:k},[(menu.isParent)?_c('v-list-group',{attrs:{"value":"true","no-action":"","prepend-icon":menu.icon}},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(menu.title)}})],1),_vm._v(" "),_vm._l((menu.children),function(child,i){return _c('v-list-tile',{key:i,attrs:{"to":child.to}},[_c('v-list-tile-action',[_c('v-icon',{domProps:{"innerHTML":_vm._s(child.icon)}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(child.title)}})],1)],1)})],2):_vm._e(),_vm._v(" "),(!menu.isParent)?_c('v-list-tile',{attrs:{"router":"","to":menu.to,"exact":""}},[_c('v-list-tile-action',[_c('v-icon',{domProps:{"innerHTML":_vm._s(menu.icon)}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(menu.title)}})],1)],1):_vm._e()],1)})],2)],1),_vm._v(" "),_c('v-toolbar',{attrs:{"fixed":"","app":"","clipped-left":_vm.clipped,"dense":""}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('v-toolbar-title',{domProps:{"textContent":_vm._s(_vm.title)}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-switch',{attrs:{"hide-details":"","label":"Dark theme"},model:{value:(_vm.isDark),callback:function ($$v) {_vm.isDark=$$v},expression:"isDark"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',{staticClass:"hidden-sm-and-down"},[_c('v-btn',{attrs:{"flat":"","block":""},on:{"click":function($event){_vm.scroll('#home')}}},[_vm._v("Home")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","block":""},on:{"click":function($event){_vm.scroll('#why')}}},[_vm._v("Why")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","block":""},on:{"click":function($event){_vm.scroll('#about')}}},[_vm._v("About")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","block":""},on:{"click":function($event){_vm.scroll('#timeline')}}},[_vm._v("Timeline")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","block":""},on:{"click":function($event){_vm.scroll('#faq')}}},[_vm._v("FAQ")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","block":""},on:{"click":function($event){_vm.scroll('#contact')}}},[_vm._v("Contact")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.rightDrawer = !_vm.rightDrawer}}},[_c('v-icon',[_vm._v("menu")])],1)],1),_vm._v(" "),_c('v-content',[_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1),_vm._v(" "),_c('v-container',{attrs:{"fluid":""}})],1),_vm._v(" "),_c('v-navigation-drawer',{attrs:{"temporary":"","right":_vm.right,"fixed":""},model:{value:(_vm.rightDrawer),callback:function ($$v) {_vm.rightDrawer=$$v},expression:"rightDrawer"}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('h2',{staticClass:"heading",attrs:{"justify-center":""}},[_vm._v(" Annoucement ")])]),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-text',[_c('p',[_vm._v("Registration for Hackathon v2.0 is now open! ")])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","color":"orange"}},[_vm._v("More")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-text',[_c('p',[_vm._v("Team selection for Hackathon v2.0 is undergoing ")])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","color":"orange"}},[_vm._v("More")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-footer',{attrs:{"fixed":_vm.fixed,"app":""}},[_c('span',{staticClass:"ma-3"},[_vm._v("Google Developers Group Addis (GDG Addis). All Rights are reserved © "+_vm._s(_vm.currentDate)+".")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HomePage__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Programs__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_About__ = __webpack_require__(125);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'HomePage',
    component: __WEBPACK_IMPORTED_MODULE_2__components_HomePage__["a" /* default */]
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_4__components_About__["a" /* default */]
  }, {
    path: '/programs',
    name: 'Programs',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Programs__["a" /* default */]
  }, {
    path: '/contact',
    name: 'contact',
    component: __WEBPACK_IMPORTED_MODULE_2__components_HomePage__["a" /* default */]
  }]
}));

/***/ }),
/* 90 */,
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomePage_vue__ = __webpack_require__(35);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_601c4192_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomePage_vue__ = __webpack_require__(104);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomePage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_601c4192_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomePage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner.0a9b8ae.jpg";

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gdg_addis.403250a.png";

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hacking.a5f5ee8.jpg";

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/image1.a6b9565.jpg";

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/image2.dc88ac0.jpg";

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.69cd1dc.png";

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/my_pic.9ce4a7d.jpg";

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/prize.2645f3c.jpg";

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/teams.b6422bd.jpg";

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/us_embassy.8095a57.png";

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{attrs:{"id":"home"}},[_c('v-parallax',{attrs:{"src":_vm.getImageUrl('banner.jpg'),"height":"680","alt":"banner image"}},[_c('v-layout',{staticClass:"white--text",attrs:{"column":"","align-center":"","justify-center":""}},[_c('img',{attrs:{"src":_vm.getImageUrl('logo.png'),"alt":"Hackathon Logo","height":"300"}}),_vm._v(" "),_c('h3',{staticClass:"display-1 text-xs-center"},[_vm._v("U.S Embassy in Ethiopia presents")]),_vm._v(" "),_c('h3',{staticClass:"white--text font-weight-bold mb-2 display-2 text-xs-center"},[_vm._v("\n          Hackathon\n          "),_c('span',{staticClass:"display-1"},[_vm._v("v2.0")])]),_vm._v(" "),_c('div',{staticClass:"title mb-4 text-xs-center"},[_vm._v("From Jan 11-13, 2018")]),_vm._v(" "),_c('div',{staticClass:"subheading mb-3 text-xs-center"},[_vm._v("@ American Center, Addis Ababa")]),_vm._v(" "),_c('v-btn',{staticClass:"blue lighten-2 mt-5",attrs:{"dark":"","large":"","href":"https://goo.gl/HEa1i6","target":"blank"}},[_vm._v("Register Here")])],1)],1)],1),_vm._v(" "),_c('section',{attrs:{"id":"why"}},[_c('v-layout',{staticClass:"my-5",attrs:{"column":"","wrap":"","align-center":""}},[_c('v-flex',{staticClass:"my-3",attrs:{"xs12":"","sm4":""}},[_c('div',{staticClass:"text-xs-center"},[_c('h2',{staticClass:"headline"},[_vm._v("The best way to demonstrate your coding skill")]),_vm._v(" "),_c('span',{staticClass:"subheading"},[_vm._v("while solving real-life challenges")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-container',{attrs:{"grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-card',{staticClass:"elevation-0 transparent"},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-icon',{staticClass:"blue--text text--lighten-2",attrs:{"x-large":""}},[_vm._v("color_lens")])],1),_vm._v(" "),_c('v-card-title',{staticClass:"layout justify-center",attrs:{"primary-title":""}},[_c('div',{staticClass:"headline text-xs-center"},[_vm._v("Design The Challenge")])]),_vm._v(" "),_c('v-card-text',[_vm._v("\n                  Hackathons help focus your design and critical thinking skills towards\n                   solving challenges.  You get the opportunity to understand the problem, \n                   analyze it, and come up with feasible solutions.\n                ")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-card',{staticClass:"elevation-0 transparent"},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-icon',{staticClass:"blue--text text--lighten-2",attrs:{"x-large":""}},[_vm._v("build")])],1),_vm._v(" "),_c('v-card-title',{staticClass:"layout justify-center",attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Build The Solution")])]),_vm._v(" "),_c('v-card-text',[_vm._v("\n                  This is about results! You will build digital solution that \n                  truly solves a problem. Team collaboration helps to develop \n                  coordination capacity, share experience, and develop a network of partners. \n                ")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-card',{staticClass:"elevation-0 transparent"},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-icon',{staticClass:"blue--text text--lighten-2",attrs:{"x-large":""}},[_vm._v("flash_on")])],1),_vm._v(" "),_c('v-card-title',{staticClass:"layout justify-center",attrs:{"primary-title":""}},[_c('div',{staticClass:"headline text-xs-center"},[_vm._v("Win Big Prizes")])]),_vm._v(" "),_c('v-card-text',[_vm._v("\n                  The teams with the top solutions will receive prizes,\n                   but everyone benefits from the experience and will have \n                   the chance to show their ideas to potential stakeholders.  \n                ")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('section',[_c('v-parallax',{attrs:{"src":_vm.getImageUrl('hacking.jpg'),"height":"380"}},[_c('v-layout',{attrs:{"column":"","align-center":"","justify-center":""}},[_c('em',[_vm._v("“Whether we're fighting climate change or going to space,\n          "),_c('br'),_vm._v("everything is moved forward by computers, and we don't\n          "),_c('br'),_vm._v("have enough people who can code.”\n          "),_c('br'),_vm._v("- Richard Branson\n        ")])])],1)],1),_vm._v(" "),_c('section',{attrs:{"id":"about"}},[_c('v-layout',{staticClass:"my-5",attrs:{"column":"","wrap":"","align-center":""}},[_c('v-flex',{staticClass:"my-3",attrs:{"xs12":"","sm4":""}},[_c('div',{staticClass:"text-xs-center"},[_c('h2',{staticClass:"headline font-weight-medium"},[_vm._v("Organized by U.S Embassy in Ethiopia")]),_vm._v(" "),_c('span',{staticClass:"subheading"},[_vm._v("#USInvestsInEthiopians")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://et.usembassy.gov/nofo-for-ethiopia-hacks/","target":"blank"}},[_vm._v("NOFO for Ethiopia Hacks")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-container',{attrs:{"grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-card',{staticClass:"elevation-0 transparent",attrs:{"target":"blank","href":"https://et.usembassy.gov/"}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('img',{attrs:{"src":_vm.getImageUrl('us_embassy.png'),"alt":"Hackathon Logo","height":"150"}})]),_vm._v(" "),_c('v-card-title',{staticClass:"layout justify-center",attrs:{"primary-title":""}},[_c('div',{staticClass:"subheading text-xs-center"},[_vm._v("U.S. Embassy")])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-card',{staticClass:"elevation-0 transparent",attrs:{"href":"https://www.usaid.gov/ethiopia","target":"blank"}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('img',{attrs:{"src":_vm.getImageUrl('usaid.png'),"alt":"Hackathon Logo","height":"150"}})]),_vm._v(" "),_c('v-card-title',{staticClass:"layout justify-center",attrs:{"primary-title":""}},[_c('div',{staticClass:"subheading text-xs-center"},[_vm._v("USAID")])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-card',{staticClass:"elevation-0 transparent",attrs:{"href":"https://www.meetup.com/GDG-Addis","target":"blank"}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('img',{attrs:{"src":_vm.getImageUrl('gdg_addis.png'),"alt":"Hackathon Logo","height":"150"}})]),_vm._v(" "),_c('v-card-title',{staticClass:"layout justify-center",attrs:{"primary-title":""}},[_c('div',{staticClass:"subheading text-xs-center"},[_vm._v("GDG Addis")])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-card',{staticClass:"elevation-0 transparent",attrs:{"href":"http://cawee-ethiopia.com/","target":"blank"}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('img',{attrs:{"src":_vm.getImageUrl('cawee.png'),"alt":"Hackathon Logo","height":"150"}})]),_vm._v(" "),_c('v-card-title',{staticClass:"layout justify-center",attrs:{"primary-title":""}},[_c('div',{staticClass:"subheading text-xs-center"},[_vm._v("CAWEE")])])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('section',{attrs:{"id":"timeline"}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-timeline',{attrs:{"align-top":""}},_vm._l((_vm.timelines),function(timeline,key){return _c('v-timeline-item',{key:key,attrs:{"color":timeline.color,"fill-dot":"","icon":timeline.icon}},[_c('v-card',[_c('v-card-title',{class:timeline.color},[_c('h2',{staticClass:"title"},[_vm._v(_vm._s(timeline.title))])]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v(_vm._s(timeline.theme))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(timeline.description))]),_vm._v(" "),(timeline.isPassed)?_c('v-btn',{staticClass:"mx-0",attrs:{"color":"success","outline":""}},[_vm._v("Passed")]):_vm._e(),_vm._v(" "),(!timeline.isPassed && timeline.isNext)?_c('v-btn',{attrs:{"href":"https://goo.gl/HEa1i6","target":"blank","color":timeline.color,"outline":""}},[_vm._v("Register Now!")]):_vm._e()],1)],1)],1)}),1)],1)],1)],1),_vm._v(" "),_c('section',[_c('v-parallax',{attrs:{"src":_vm.getImageUrl('teams.jpg'),"height":"200"}},[_c('v-layout',{attrs:{"column":"","align-center":"","justify-center":""}})],1)],1),_vm._v(" "),_c('section',{attrs:{"id":"faq"}},[_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"column":"","align-center":""}},[_c('h4',{staticClass:"display-1"},[_vm._v("FAQ")])]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.faqList),function(faq,key){return _c('v-flex',{key:key,attrs:{"xs12":"","md6":"","lg6":""}},[_c('v-expansion-panel',{attrs:{"popout":""}},[_c('v-expansion-panel-content',[_c('v-layout',{attrs:{"slot":"header","align-center":"","row":"","spacer":""},slot:"header"},[_c('v-flex',{attrs:{"no-wrap":"","xs15":""}},[_c('p',[_vm._v(_vm._s(faq.question))])])],1),_vm._v(" "),_c('v-card',[_c('v-divider'),_vm._v(" "),_c('v-card-text',{domProps:{"textContent":_vm._s(faq.answer)}})],1)],1)],1)],1)}),1)],1),_vm._v(" "),_c('section',{attrs:{"id":"contact"}},[_c('v-container',{attrs:{"grid-list-xl":""}},[_c('v-layout',{staticClass:"my-5",attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-card',{staticClass:"elevation-0 transparent"},[_c('v-card-title',{staticClass:"layout justify-center",attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Program Objective")])]),_vm._v(" "),_c('v-card-text',[_vm._v("\n              Ethiopia is the second most-populous country in Africa with more than 70% of its population\n              under the age of 35. This population of youth faces enormous challenges in terms of education,\n              employment, access to technology and opportunities to create and innovate.\n              Hackathon participants are between the of 18-25 thus hosting a Hackathon allows to understand\n              how best to inspire Ethiopian youth to imagine, plan, design, compose, invent, create, innovate,\n              build and construct. The program aims to make the most diverse hackathon sessions with a goal\n              of 35% participation from women in each session.\n            ")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","offset-sm1":""}},[_c('v-card',{staticClass:"elevation-0 transparent"},[_c('v-card-title',{staticClass:"layout justify-center",attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Contact us")])]),_vm._v(" "),_c('v-card-text',[_vm._v("Do you want to contact the organizers? Please don't hesitate to contact through the following addresses.")]),_vm._v(" "),_c('v-list',{staticClass:"transparent"},[_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{staticClass:"blue--text text--lighten-2"},[_vm._v("phone")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("+251-910331122")])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{staticClass:"blue--text text--lighten-2"},[_vm._v("place")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("American Centers in Ethiopia")])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{staticClass:"blue--text text--lighten-2"},[_vm._v("email")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("gdgaddis.et@gmail.com")])],1)],1)],1)],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Programs_vue__ = __webpack_require__(37);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecfac02c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Programs_vue__ = __webpack_require__(124);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Programs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecfac02c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Programs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Intro_vue__ = __webpack_require__(38);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3139e5a5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Intro_vue__ = __webpack_require__(107);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Intro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3139e5a5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Intro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md8":"","lg8":""}},[_c('section',[_c('v-parallax',{attrs:{"src":_vm.getImageUrl('hackv1/image1.jpg'),"height":"380"}},[_c('v-layout',{attrs:{"column":"","align-center":"","justify-center":""}})],1)],1),_vm._v(" "),_c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_vm._v("Youth and Entrepreneurship")]),_vm._v(" "),_c('v-card-text',[_c('h3',{staticClass:"headline"},[_vm._v("Hackathon v1.0")]),_vm._v(" "),_c('p',[_vm._v("\n            “Ethiopia Hack” Hackathon v1.0 is one of the 12 hackathon programs\n            and it was conducted from Nov 16th to Nov 18 th, 2018 at American Center,\n            inside NALA, Addis Ababa, Ethiopia.\n          ")]),_vm._v(" "),_c('h3',{staticClass:"display-1"},[_vm._v("Problem Statement")]),_vm._v(" "),_c('blockquote',{staticClass:"blockquote"},[_c('p',[_vm._v("\n              “In Ethiopia plenty of trucks (1.5 – 40.0 tons) are driving empty in one direction to reach\n              their destination e.g. Djibouti. This increased cost and wear and tear of tires and\n              equipment without generating revenue. On the same road potential customers are waiting\n              for transport so that their goods will be transported to the next town, etc.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              A system should be developed that addresses the issue by which customers can call\n              (USSD or call center) and ask for a transport service. This call will go out to drivers that\n              are in the nearby area. The system will have registered about 5,000 certified truck\n              drivers with their certified trucks incl. load capacity. If the driver agrees, he will receive\n              further instructions and a contract will be signed using USSD. Distances and prices are\n              calculated based on a standardized pricing system. After the customer and driver are\n              satisfied (a feedback is given by the customer and the truck driver) with the agreed\n              service the contract amount will be transferred via mobile money. The public can see the\n              satisfaction of the customer with the driver and the delivery of goods. The application\n              needs to be developed in at last three local languages.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              With this application the prices for the service can be reduced over time while the income\n              for the truck drivers can increase. As truck drivers get regular information about\n              potential clients they are better informed and can adequately make business decisions.”\n            ")])])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":"","lg4":""}},[_c('v-card',{staticStyle:{"margin":"5px"},attrs:{"elevation-20":""}},[_c('v-card-title',[_vm._v(_vm._s(_vm.mainSideInfo.title)+"\n          "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"error","flat":""}},[_vm._v("passed!")])],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"column":""}},[_c('h3',{staticClass:"header"},[_vm._v("Theme")]),_vm._v(" "),_c('h4',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.mainSideInfo.theme))]),_vm._v(" "),_c('h3',{staticClass:"header",staticStyle:{"margin-top":"10px"}},[_vm._v("@"+_vm._s(_vm.mainSideInfo.venue))]),_vm._v(" "),_c('h4',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.mainSideInfo.city))]),_vm._v(" "),_c('h3',{staticClass:"header",staticStyle:{"margin-top":"30px"},attrs:{"pa-3":""}},[_vm._v("Program Schedule")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-space-between":"","ma-2":""}},[_c('v-layout',{attrs:{"column":"","align-center":""}},[_c('v-icon',[_vm._v("mdi-calendar")]),_vm._v(" "),_c('span',{staticClass:"caption"},[_vm._v("Start Date")]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.mainSideInfo.startDate))])],1),_vm._v(" "),_c('v-layout',{attrs:{"column":"","align-center":""}},[_c('v-icon',[_vm._v("mdi-calendar-check")]),_vm._v(" "),_c('span',{staticClass:"caption"},[_vm._v("End Date")]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.mainSideInfo.endDate))])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"40px"}},[_vm._v("\n              For for more information, please contact us\n              "),_c('a',{attrs:{"href":"/contact"}},[_vm._v("here")])])],1)],1)],1),_vm._v(" "),_c('v-card',{staticStyle:{"margin":"5px"},attrs:{"elevation-20":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":"","justify-space-between":""}},_vm._l((_vm.attendee_statistics),function(stat,key){return _c('v-layout',{key:key,attrs:{"column":"","justify-start":"","align-center":""}},[_c('v-icon',[_vm._v(_vm._s(stat.icon))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(stat.desc))])],1)}),1)],1)],1),_vm._v(" "),_c('v-card',{staticStyle:{"margin":"5px"},attrs:{"elevation-20":""}},[_c('v-card-title',[_c('span',{staticClass:"display-1"},[_vm._v("Prize")]),_vm._v(" "),_c('span',{staticClass:"subheading"},[_vm._v("for each winning team members")])]),_vm._v(" "),_c('v-card-text',[_c('v-sheet',{staticClass:"d-flex",attrs:{"color":"cyan lighten-1"}},[_c('v-layout',{staticStyle:{"margin":"5px"},attrs:{"row":"","wrap":"","justify-space-between":"","elevation":"12"}},[_c('span',{staticClass:"display-1"},[_vm._v("1")]),_vm._v(" "),_c('span',{staticClass:"caption"},[_vm._v("st")]),_vm._v(" "),_c('v-layout',{attrs:{"column":"","align-end":""}},[_c('span',{staticClass:"subheading"},[_vm._v("1TB Hard Disk")]),_vm._v(" "),_c('span',{staticClass:"subheading"},[_vm._v("Backpack")])])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-sheet',{staticClass:"d-flex",attrs:{"color":"teal lighten-1"}},[_c('v-layout',{staticStyle:{"margin":"5px"},attrs:{"row":"","wrap":"","justify-space-between":""}},[_c('span',{staticClass:"display-1"},[_vm._v("2")]),_vm._v(" "),_c('span',{staticClass:"caption"},[_vm._v("nd")]),_vm._v(" "),_c('v-layout',{attrs:{"column":"","align-end":""}},[_c('span',{staticClass:"subheading"},[_vm._v("128 GB Flash Disk")]),_vm._v(" "),_c('span',{staticClass:"subheading"},[_vm._v("Backpack")]),_vm._v(" "),_c('span',{staticClass:"subheading"},[_vm._v("Power Bank: for mobile phones")])])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-sheet',{staticClass:"d-flex",attrs:{"color":"green lighten-3"}},[_c('v-layout',{staticStyle:{"margin":"5px"},attrs:{"row":"","wrap":"","justify-space-between":""}},[_c('span',{staticClass:"display-1"},[_vm._v("3")]),_vm._v(" "),_c('span',{staticClass:"caption"},[_vm._v("rd")]),_vm._v(" "),_c('v-layout',{attrs:{"column":"","align-end":""}},[_c('span',{staticClass:"subheading"},[_vm._v("Wireless Bluetooth Mouse")]),_vm._v(" "),_c('span',{staticClass:"subheading"},[_vm._v("Backpack")]),_vm._v(" "),_c('span',{staticClass:"subheading"},[_vm._v("Waterbottle with Stickers Branding")])])],1)],1)],1)],1),_vm._v(" "),_c('v-card',{staticStyle:{"margin":"5px"},attrs:{"elevation-20":""}},[_c('v-card-media',{staticClass:"red--text",attrs:{"src":_vm.getImageUrl('hackv1/image1.jpg'),"height":"200px"}})],1),_vm._v(" "),_c('v-card',{staticStyle:{"margin":"5px"},attrs:{"elevation-20":""}},[_c('v-card-title',{staticClass:"subheading"},[_vm._v("Participant Feedback")]),_vm._v(" "),_vm._l((_vm.feedbacks),function(feedback,key){return _c('v-card-text',{key:key},[_c('em',[_vm._v(_vm._s(feedback))])])})],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Teams_vue__ = __webpack_require__(40);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9af1b0a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Teams_vue__ = __webpack_require__(109);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Teams_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9af1b0a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Teams_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('v-container',{attrs:{"grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-space-between":""}},_vm._l((_vm.teams),function(team,key){return _c('v-flex',{key:key,attrs:{"xs12":"","sm-6":"","md4":"","lg4":""}},[_c('v-card',[_c('v-card-media',{staticClass:"red--text",attrs:{"src":_vm.getImageUrl(team.image),"height":"200px"}}),_vm._v(" "),_c('v-card-title',[_c('div',[_c('span',{staticClass:"headline gray--text"},[_vm._v(_vm._s(team.name))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-space-between":""}},_vm._l((team.members),function(memb,i){return _c('v-flex',{key:i,attrs:{"xs6":""}},[_c('span',{staticClass:"caption"},[_vm._v(" "+_vm._s(memb))])])}),1)],1)]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","color":"blue-grey lighten-1"}},[_c('v-icon',[_vm._v("mdi-thumb-up")]),_vm._v(" 14")],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"blue-grey lighten-1"}},[_c('v-icon',[_vm._v("mdi-eye")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"blue-grey lighten-1"}},[_c('v-icon',[_vm._v("mdi-share-variant")])],1)],1)],1)],1)}),1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Schedule_vue__ = __webpack_require__(41);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a8ab780_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Schedule_vue__ = __webpack_require__(111);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Schedule_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a8ab780_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Schedule_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.schedules),function(sch,key){return _c('v-flex',{key:key,attrs:{"xs12":"","sm12":"","md4":"","lg4":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card',{attrs:{"dark":"","flat":""}},[_c('v-card-text',[_c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('strong',{staticClass:"display-4 font-weight-regular mr-4"},[_vm._v(_vm._s(sch.day))]),_vm._v(" "),_c('v-layout',{attrs:{"column":"","justify-end":""}},[_c('div',{staticClass:"headline font-weight-light"},[_vm._v(_vm._s(sch.dayOfWeek))]),_vm._v(" "),_c('div',{staticClass:"text-uppercase font-weight-light"},[_vm._v(_vm._s(sch.month)+" "+_vm._s(sch.year))])])],1)],1)],1)],1),_vm._v(" "),_c('v-card-text',{staticClass:"py-0"},[_c('v-timeline',{attrs:{"align-top":"","dense":""}},_vm._l((sch.agendas),function(agenda,i){return _c('v-timeline-item',{key:i,attrs:{"color":i%2 == 0?'pink': 'teal lighten-3',"small":""}},[_c('v-layout',{attrs:{"justify-space-between":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('strong',[_vm._v(_vm._s(agenda.time)+":")])]),_vm._v(" "),_c('v-flex',[_c('strong',[_vm._v(_vm._s(agenda.agenda))]),_vm._v(" "),_c('div',{staticClass:"caption"},[_vm._v(_vm._s(agenda.caption))])])],1)],1)}),1)],1)],1)],1)}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dc7ae83_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Guideline_vue__ = __webpack_require__(113);
var normalizeComponent = __webpack_require__(6)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dc7ae83_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Guideline_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-auto"},[_c('v-card-title',{staticClass:"blue-grey white--text"},[_c('span',{staticClass:"title"},[_vm._v("Guidelines and Rules")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',{staticClass:"py-0"},[_c('v-timeline',{attrs:{"dense":""}},[_c('v-slide-x-reverse-transition',[_c('v-timeline-item',{attrs:{"color":"green lighten-3","fill-dot":""}},[_c('span',{attrs:{"slot":"icon"},slot:"icon"},[_vm._v("1")]),_vm._v(" "),_c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_c('span',{staticClass:"title"},[_vm._v("Program Objective")])]),_vm._v(" "),_c('v-card-text',[_vm._v("Lorem ipsum dolor sit amet, no nam oblique veritus. Commune scaevola imperdiet nec ut, sed euismod convenire principes at. Est et nobis iisque percipit, an vim zril disputando voluptatibus, vix an salutandi sententiae.")])],1)],1)],1),_vm._v(" "),_c('v-slide-x-reverse-transition',[_c('v-timeline-item',{attrs:{"color":"blue lighten-3","fill-dot":""}},[_c('span',{attrs:{"slot":"icon"},slot:"icon"},[_vm._v("2")]),_vm._v(" "),_c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_c('span',{staticClass:"title"},[_vm._v("Code of Conduct")])]),_vm._v(" "),_c('v-card-text',[_vm._v("Lorem ipsum dolor sit amet, no nam oblique veritus. Commune scaevola imperdiet nec ut, sed euismod convenire principes at. Est et nobis iisque percipit, an vim zril disputando voluptatibus, vix an salutandi sententiae.")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e596a5c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Winners_vue__ = __webpack_require__(115);
var normalizeComponent = __webpack_require__(6)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e596a5c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Winners_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v("Winners Page")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gallery_vue__ = __webpack_require__(42);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b32816e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gallery_vue__ = __webpack_require__(121);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gallery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b32816e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gallery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 117 */,
/* 118 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 119 */,
/* 120 */,
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Gallery Page")]),_vm._v(" "),_c('gallery',{attrs:{"images":_vm.images,"index":_vm.index},on:{"close":function($event){_vm.index = null}}}),_vm._v(" "),_vm._l((_vm.images),function(image,imageIndex){return _c('div',{key:imageIndex,staticClass:"image",on:{"click":function($event){_vm.index = imageIndex}}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_128c365c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Discussion_vue__ = __webpack_require__(123);
var normalizeComponent = __webpack_require__(6)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_128c365c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Discussion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',[_vm._v("Comming Soon...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{attrs:{"tabs":""}},[_c('v-toolbar-title',[_vm._v("Hackathon v1.0 "),_c('span',{staticClass:"subheading"},[_vm._v("\"Youth and Entrepreneurship\"")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',{staticClass:"caption"},[_vm._v("Nov 16 to 18, 2018 @American Center, Addis Ababa")]),_vm._v(" "),_c('v-tabs',{attrs:{"slot":"extension","fixed-tabs":"","icons-and-text":"","centered":""},slot:"extension",model:{value:(_vm.tabs),callback:function ($$v) {_vm.tabs=$$v},expression:"tabs"}},[_c('v-tabs-slider'),_vm._v(" "),_vm._l((_vm.tabList),function(tab,key){return _c('v-tab',{key:key,attrs:{"href":'#tab-'+ key}},[_vm._v("\n        "+_vm._s(tab.title)+"\n        "),_c('v-icon',[_vm._v(_vm._s(tab.icon))])],1)})],2)],1),_vm._v(" "),_c('v-tabs-items',{staticClass:"elevation-1",model:{value:(_vm.tabs),callback:function ($$v) {_vm.tabs=$$v},expression:"tabs"}},_vm._l((_vm.tabList),function(tab,i){return _c('v-tab-item',{key:i,attrs:{"id":'tab-' + i}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[(i == 0)?_c('intro-page'):_vm._e(),_vm._v(" "),(i == 1)?_c('teams-page'):_vm._e(),_vm._v(" "),(i == 2)?_c('schedule-page'):_vm._e(),_vm._v(" "),(i == 3)?_c('guideline-page'):_vm._e(),_vm._v(" "),(i == 4)?_c('winners-page'):_vm._e(),_vm._v(" "),(i == 5)?_c('gallery-page'):_vm._e(),_vm._v(" "),(i == 6)?_c('discussion-page'):_vm._e()],1)],1)],1)}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_925c9b98_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__(126);
var normalizeComponent = __webpack_require__(6)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_925c9b98_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("About Page")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 147 */,
/* 148 */,
/* 149 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 154 */,
/* 155 */,
/* 156 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 157 */,
/* 158 */,
/* 159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 168 */,
/* 169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 170 */,
/* 171 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 198 */,
/* 199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 200 */,
/* 201 */,
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */,
/* 204 */,
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */,
/* 216 */,
/* 217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 218 */,
/* 219 */,
/* 220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 226 */,
/* 227 */,
/* 228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 229 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
]),[54]);


// WEBPACK FOOTER //
// static/js/app.978f0b2cf0d764de7a7d.js